import { Box, Typography, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import { Link } from 'evee-ui-common/components/base';
import { getHomeUrl } from 'evee-ui-common/utils';
import useRegion from 'store/modules/app/hooks/useRegion';

const NovatedLeasing = () => {
  const { region } = useRegion();

  return (
    <Box display="flex" justifyContent="center">
      <Box
        style={{
          textAlign: 'center',

          whiteSpace: 'pre-line',
        }}
      >
        <Typography gutterBottom component="h3" variant="h5">
          Thinking about owning your own EV?{'\n'}
        </Typography>
        <Typography>
          <Link
            href={getHomeUrl(region) + '/pages/novated-leasing'}
            style={{ fontWeight: 'normal' }}
          >
            Explore a novated lease
          </Link>{' '}
          — you could save up to $10k/year on tax.{'\n'}
          Rent it out and save even more.
        </Typography>
      </Box>
    </Box>
  );
};

export default NovatedLeasing;
